// What the sync pill says about the last sync (WI-40 #8): "Synced · 20:55" was still showing at
// 08:56 the next morning, with no day. Now it says the day when it isn't today.
import { fmt, t } from '../strings/en'

/** YYYY-MM-DD of `ms` in `tz`. */
const dayOf = (ms: number, tz: string) => new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).format(ms)

/** Whole calendar days from day `a` to day `b` (YYYY-MM-DD). */
const daysApart = (a: string, b: string) => Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86_400_000)

/** "Synced just now", "Synced · 20:55" (today), "Synced yesterday 20:55", "Synced 3 days ago". */
export function syncedLabel(lastSyncAt: number, now: number, tz: string): string {
  if (now - lastSyncAt < 60_000) return t.sync.syncedNow
  const days = daysApart(dayOf(lastSyncAt, tz), dayOf(now, tz))
  if (days <= 0) return t.sync.synced(fmt.hhmm(lastSyncAt, tz))
  if (days === 1) return t.sync.syncedYesterday(fmt.hhmm(lastSyncAt, tz))
  return t.sync.syncedDaysAgo(days)
}

/** The same for the offline banner's "synced …" (lower case, after a ·). */
export function syncedShort(lastSyncAt: number, now: number, tz: string): string {
  const s = syncedLabel(lastSyncAt, now, tz).replace(/^Synced · /, '').replace(/^Synced /, '')
  return s
}
